<div class="color-picker">
  <div
    class="circle"
    [ngStyle]="{ background: color() }"
    (click)="openColorPickerWindow($event)"
  ></div>
</div>
